/* Infused Lights — menu close chip only (v7). No layout fights. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    var canvas = document.getElementById('nt_menu_canvas');
    if (!canvas) return;
    var html = document.documentElement;
    var body = document.body;

    var btn = document.getElementById('infuse-menu-close');
    if (!btn) {
      btn = document.createElement('button');
      btn.id = 'infuse-menu-close';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Close menu');
      btn.textContent = 'Close';
      document.body.appendChild(btn);
    } else if (!btn.parentNode) {
      document.body.appendChild(btn);
    }

    function isOpen() {
      return html.classList.contains('hside_opened') || body.classList.contains('pside_opened') || canvas.classList.contains('act_opened');
    }

    function sync() {
      if (isOpen()) {
        btn.classList.add('is-on');
        // re-append so it stays on top of theme layers
        if (btn.parentNode !== document.body) document.body.appendChild(btn);
      } else {
        btn.classList.remove('is-on');
      }
    }

    function closeMenu(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      html.classList.remove('hside_opened');
      body.classList.remove('pside_opened');
      canvas.classList.remove('act_opened');
      document.querySelectorAll('.push_side.act_current, .push-menu-btn.act_current, .act_current').forEach(function (el) {
        el.classList.remove('act_current');
      });
      document.querySelectorAll('.mask-overlay').forEach(function (el) {
        el.classList.remove('mask_opened');
        el.style.display = 'none';
      });
      btn.classList.remove('is-on');
    }

    btn.addEventListener('click', closeMenu, true);
    btn.addEventListener('touchend', closeMenu, { passive: false, capture: true });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && isOpen()) closeMenu(e);
    });

    var obs = new MutationObserver(function () { sync(); });
    obs.observe(html, { attributes: true, attributeFilter: ['class'] });
    obs.observe(body, { attributes: true, attributeFilter: ['class'] });
    obs.observe(canvas, { attributes: true, attributeFilter: ['class'] });
    sync();
    setInterval(sync, 800);
  });
})();
